import React from 'react';
import styled from 'styled-components';

import type { IFormSelectGroup } from './types';

import { SelectGroup } from './SelectGroup';

interface IProps extends IFormSelectGroup {
  className?: string;
  page: number;
  pageCount: number;
}

const PaginationSelectGroup = ({ className, page, pageCount, ...selectProps }: IProps): React.ReactElement => {
  return (
    <PaginationWrapper className={className} page={page} total={pageCount}>
      <SelectGroup {...selectProps} />
    </PaginationWrapper>
  );
};

export { PaginationSelectGroup };

const PaginationWrapper = styled.div<{ page: number; total: number }>`
  ${props =>
    props.page === 0 &&
    `.item-prev {
        pointer-events: none;
        filter: grayscale(100%);
      }`}

  ${props =>
    props.page >= props.total &&
    `.item-next {
        pointer-events: none;
        filter: grayscale(100%);
      }`}

  ${props =>
    props.total === 0 &&
    `.item-prev, .item-next {
        pointer-events: none;
        filter: grayscale(100%);
      }`}
`;
